import {
  Avatar,
  TextField,
  Button,
  Stack,
  MenuItem,
  Select,
  FormControl,
  Icon,
  Chip,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import DraftsIcon from "@mui/icons-material/Drafts";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import moment from "moment";
import CONSTANTS from "../constant.json";
import ImgsViewer from "react-images-viewer";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { get, post } from "../Services/services";
import { forEach } from "lodash";
import { Tag, TagSharp } from "@mui/icons-material";
import { render } from "@testing-library/react";

function CaseDetailsHeadedCard(props) {
  const [imageOpen, setImageOpen] = React.useState(false);
  const {
    isEditing,
    editedData,
    onEditClick,
    onCancelEdit,
    onSaveEdit,
    onFieldChange,
    fetchCase,
    stateData,
    boardData,
    careerOptionData,
    sourceData,
    occupationData,
    courseData,
    studentTags,
    bloodGroups,
    PreviousClass,
    nextExpectedCourse
  } = props;

  const caseData = isEditing ? editedData?.case : fetchCase?.case;
  const originalCaseData = fetchCase?.case; // Keep reference to original data
  const [selectedStudentTags, setSelectedStudentTags] = useState([]);
  const [mobileError, setMobileError] = useState("");
  const [fatherMobileError, setFatherMobileError] = useState("");
  const [motherMobileError, setMotherMobileError] = useState("");
  const [guardianMobileError, setGuardianMobileError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [aadharError, setAadharError] = useState("");
  const [percentageError, setPercentageError] = useState("");
const [pincodeError, setPincodeError] = useState("");
const [currentPincodeError, setCurrentPincodeError] = useState("");
const [nameError, setNameError] = useState("");
const [fatherNameError, setFatherNameError] = useState("");
const [motherNameError, setMotherNameError] = useState("");
const [guardianNameError, setGuardianNameError] = useState("");
  
const handleFieldChange = (field) => (e) => {
  const value = e.target.value;
  
  if (["mobile", "fatherMobile", "motherMobile", "guardianMobile"].includes(field)) {
    if (/^[0-9]*$/.test(value) || value === "") {
      onFieldChange(field, value);
      validateMobileNumber(value, field);
    }
  } 
  else if (field === "email") {
    onFieldChange(field, value);
    validateEmail(value);
  }
  else if (field === "aadharNo") {
    if (/^[0-9]*$/.test(value) || value === "") {
      onFieldChange(field, value);
      validateAadharNumber(value);
    }
  }
  else if (field === "prevYearMark") {
    if (/^[0-9]*\.?[0-9]*$/.test(value) || value === "") {
      onFieldChange(field, value);
      validatePercentage(value);
    }
  }
  else if (["postalCode", "currentPostalCode"].includes(field)) {
    if (/^[0-9]*$/.test(value) || value === "") {
      onFieldChange(field, value);
      validatePincode(value, field);
    }
  }
  else if (["name", "fatherName", "motherName", "guardianName"].includes(field)) {
    if (/^[a-zA-Z\s]*$/.test(value) || value === "") {
      onFieldChange(field, value);
      validateName(value, field);
    }
  }
  else {
    onFieldChange(field, value);
  }
};

const validatePincode = (value, field) => {
  let setError;
  switch (field) {
    case "postalCode": setError = setPincodeError; break;
    case "currentPostalCode": setError = setCurrentPincodeError; break;
    default: setError = setPincodeError;
  }

  if (value) {
    if (!/^\d+$/.test(value)) {
      setError("Pincode must contain only digits");
    } else if (value.length !== 6) {
      setError("Pincode must be exactly 6 digits");
    } else {
      setError("");
    }
  } else {
    setError("");
  }
};

// Name validation
const validateName = (value, field) => {
  let setError;
  switch (field) {
    case "name": setError = setNameError; break;
    case "fatherName": setError = setFatherNameError; break;
    case "motherName": setError = setMotherNameError; break;
    case "guardianName": setError = setGuardianNameError; break;
    default: setError = setNameError;
  }

  if (value) {
    if (!/^[a-zA-Z\s]*$/.test(value)) {
      setError("Name must contain only alphabets and spaces");
    } else {
      setError("");
    }
  } else {
    setError("");
  }
};

  // Date change handler
  const handleDateChange = (date) => {
    onFieldChange("dob", date ? date.toISOString() : null);
  };

  // Mobile number validation
  const validateMobileNumber = (value, field) => {
    let setError;
    switch (field) {
      case "mobile": setError = setMobileError; break;
      case "fatherMobile": setError = setFatherMobileError; break;
      case "motherMobile": setError = setMotherMobileError; break;
      case "guardianMobile": setError = setGuardianMobileError; break;
      default: setError = setMobileError;
    }

    if (value) {
      if (!/^\d+$/.test(value)) {
        setError("Mobile number must contain only digits");
      } else if (value.length !== 10) {
        setError("Mobile number must be exactly 10 digits");
      } else {
        setError("");
      }
    } else {
      setError("");
    }
  };

  // Aadhar number validation
  const validateAadharNumber = (value) => {
    if (!value) {
      setAadharError("");
      return;
    }

    if (!/^\d+$/.test(value)) {
      setAadharError("Aadhar number must contain only digits");
    } else if (value.length !== 12) {
      setAadharError("Aadhar number must be exactly 12 digits");
    } else {
      setAadharError("");
    }
  };

  // Percentage validation
  const validatePercentage = (value) => {
    if (!value) {
      setPercentageError("");
      return;
    }

    const numericValue = parseFloat(value);
    if (isNaN(numericValue)) {
      setPercentageError("Please enter a valid percentage");
    } else if (numericValue > 100) {
      setPercentageError("Percentage cannot be greater than 100");
    } else if (numericValue < 0) {
      setPercentageError("Percentage cannot be negative");
    } else {
      setPercentageError("");
    }
  };

  // Email validation for Gmail format
  const validateEmail = (value) => {
    if (!value) {
      setEmailError("");
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

const handleSelectFieldChange = (field) => (e) => {
  const selectedId = e.target.value;
  
  if (field.includes('.')) {
    const [parentField, childField] = field.split('.');
    const currentParentValue = caseData?.[parentField] || {};
    const updatedParentValue = {
      ...currentParentValue,
      [childField]: selectedId
    };
    onFieldChange(parentField, updatedParentValue);
  } else {
    onFieldChange(field, selectedId);
  }
};

  const handleMultipleTagsChange = (event) => {
    const {
      target: { value },
    } = event;
    
    const selectedValues = typeof value === 'string' ? value.split(',') : value;
    setSelectedStudentTags(selectedValues);
    
    onFieldChange("studentTagsId", selectedValues);
  };


  const findOptionById = (options, id) => {
    if (!options || !Array.isArray(options) || !id) return null;
    return options.find(option => option.id === id || option._id === id);
  };

  const getDisplayNameById = (options, id) => {
    if (!options || !Array.isArray(options) || !id) return "";
    const option = findOptionById(options, id);
    return option ? (option.name || option.title || option.label || "") : "";
  };


const getCurrentValue = (field) => {
  if (field.includes('.')) {
    const [parentField, childField] = field.split('.');
    const parentValue = caseData?.[parentField];
    if (parentValue && typeof parentValue === 'object') {
      const childValue = parentValue[childField];
      // Return the actual value, whether it's an ID or an object
      if (childValue && typeof childValue === "object" && (childValue.id || childValue._id)) {
        return childValue.id || childValue._id;
      }
      return childValue || "";
    }
    return "";
  }
  
  const value = caseData?.[field];
  if (!value) return "";
  
  if (typeof value === "object" && (value.id || value._id)) {
    return value.id || value._id;
  }
  
  return value;
};


const isFieldModified = (field) => {
  if (!isEditing || !originalCaseData) return false;
  
  if (field.includes('.')) {
    const [parentField, childField] = field.split('.');
    const currentParentValue = caseData?.[parentField];
    const originalParentValue = originalCaseData?.[parentField];
    
    const currentValue = currentParentValue?.[childField];
    const originalValue = originalParentValue?.[childField];
    
    return currentValue !== originalValue;
  }
  
  const currentValue = caseData?.[field];
  const originalValue = originalCaseData?.[field];
  
  if (field === "studentTagsId") {
    const currentTags = Array.isArray(currentValue) ? currentValue : (currentValue ? [currentValue] : []);
    const originalTags = Array.isArray(originalValue) ? originalValue : (originalValue ? [originalValue] : []);
    return JSON.stringify(currentTags.sort()) !== JSON.stringify(originalTags.sort());
  }
  
  return currentValue !== originalValue;
};

  const shouldShowField = (field, displayValue, isDropdown = false) => {
    if (isEditing && (field === "countryId" || field === "RegisteredAt")) {
      return false;
    }
    
    if (isEditing) {
      return isFieldModified(field) || (displayValue !== undefined && displayValue !== null && displayValue !== "");
    }
    
    if (isDropdown) {
      return displayValue !== undefined && displayValue !== null && displayValue !== "";
    }
    
    return displayValue !== undefined && displayValue !== null && displayValue !== "";
  };

  


const renderField = (
  field,
  label,
  displayValue,
  width = "w-64",
  options = null
) => {
  if (field === "dob") {
    if (isEditing) {
      return (
        <div className={`${width} p-2 py-2 ${isFieldModified(field) ? 'bg-yellow-50 border-l-4 border-yellow-400' : ''}`}>
          <h1 className="text-gray-500">{label} {isFieldModified(field) && <span className="text-yellow-600 text-xs">(Modified)</span>}</h1>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              value={caseData?.dob ? moment(caseData.dob) : null}
              onChange={(newValue) => {
                onFieldChange("dob", newValue ? newValue.toISOString() : null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  variant="standard"
                  InputProps={{ 
                    ...params.InputProps,
                    disableUnderline: true 
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: 0,
                      fontSize: "inherit",
                      fontFamily: "inherit",
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </div>
      );
    } else if (caseData?.dob) {
      return (
        <div className={`${width} p-2 py-2`}>
          <h1 className="text-gray-500">{label}</h1>
          <h1 className="break-words whitespace-normal" title={moment(caseData.dob).format("MMMM Do YYYY")}>
            {moment(caseData.dob).format("MMMM Do YYYY")}
          </h1>
        </div>
      );
    }
    return null;
  }

    // Special case for mobile number fields
    if (["mobile", "fatherMobile", "motherMobile", "guardianMobile"].includes(field)) {
      const errorState = {
        mobile: mobileError,
        fatherMobile: fatherMobileError,
        motherMobile: motherMobileError,
        guardianMobile: guardianMobileError
      }[field];

      if (isEditing) {
        return (
          <div className={`${width} p-2 py-2 ${isFieldModified(field) ? 'bg-yellow-50 border-l-4 border-yellow-400' : ''}`}>
            <h1 className="text-gray-500">{label} {isFieldModified(field) && <span className="text-yellow-600 text-xs">(Modified)</span>}</h1>
            <TextField
              value={caseData?.[field] || ""}
              onChange={handleFieldChange(field)}
              fullWidth
              size="small"
              variant="standard"
              error={!!errorState}
              helperText={errorState}
              inputProps={{ 
                maxLength: 10,
                inputMode: "numeric"
              }}
              InputProps={{ disableUnderline: true }}
              sx={{
                "& .MuiInputBase-input": {
                  padding: 0,
                  fontSize: "inherit",
                  fontFamily: "inherit",
                },
                "& .MuiFormHelperText-root": {
                  color: "red",
                  marginLeft: 0
                }
              }}
            />
          </div>
        );
      } else if (displayValue) {
        return (
          <div className={`${width} p-2 py-2`}>
            <h1 className="text-gray-500">{label}</h1>
            <h1 className="break-words whitespace-normal" title={displayValue}>{displayValue}</h1>
          </div>
        );
      }
      return null;
    }

    if (field === "aadharNo") {
      if (isEditing) {
        return (
          <div className={`${width} p-2 py-2 ${isFieldModified(field) ? 'bg-yellow-50 border-l-4 border-yellow-400' : ''}`}>
            <h1 className="text-gray-500">{label} {isFieldModified(field) && <span className="text-yellow-600 text-xs">(Modified)</span>}</h1>
            <TextField
              value={caseData?.[field] || ""}
              onChange={handleFieldChange(field)}
              fullWidth
              size="small"
              variant="standard"
              error={!!aadharError}
              helperText={aadharError}
              inputProps={{ 
                maxLength: 12,
                inputMode: "numeric"
              }}
              InputProps={{ disableUnderline: true }}
              sx={{
                "& .MuiInputBase-input": {
                  padding: 0,
                  fontSize: "inherit",
                  fontFamily: "inherit",
                },
                "& .MuiFormHelperText-root": {
                  color: "red",
                  marginLeft: 0
                }
              }}
            />
          </div>
        );
      } else if (displayValue) {
        return (
          <div className={`${width} p-2 py-2`}>
            <h1 className="text-gray-500">{label}</h1>
            <h1 className="break-words whitespace-normal" title={displayValue}>{displayValue}</h1>
          </div>
        );
      }
      return null;
    }

    // Special case for percentage field
    if (field === "prevYearMark") {
      if (isEditing) {
        return (
          <div className={`${width} p-2 py-2 ${isFieldModified(field) ? 'bg-yellow-50 border-l-4 border-yellow-400' : ''}`}>
            <h1 className="text-gray-500">{label} {isFieldModified(field) && <span className="text-yellow-600 text-xs">(Modified)</span>}</h1>
            <TextField
              value={caseData?.[field] || ""}
              onChange={handleFieldChange(field)}
              fullWidth
              size="small"
              variant="standard"
              error={!!percentageError}
              helperText={percentageError}
              inputProps={{ 
                inputMode: "decimal"
              }}
              InputProps={{ disableUnderline: true }}
              sx={{
                "& .MuiInputBase-input": {
                  padding: 0,
                  fontSize: "inherit",
                  fontFamily: "inherit",
                },
                "& .MuiFormHelperText-root": {
                  color: "red",
                  marginLeft: 0
                }
              }}
            />
          </div>
        );
      } else if (displayValue) {
        return (
          <div className={`${width} p-2 py-2`}>
            <h1 className="text-gray-500">{label}</h1>
            <h1 className="break-words whitespace-normal" title={displayValue}>{displayValue}</h1>
          </div>
        );
      }
      return null;
    }

    if (["postalCode", "currentPostalCode"].includes(field)) {
  const errorState = {
    postalCode: pincodeError,
    currentPostalCode: currentPincodeError
  }[field];

  if (isEditing) {
    return (
      <div className={`${width} p-2 py-2 ${isFieldModified(field) ? 'bg-yellow-50 border-l-4 border-yellow-400' : ''}`}>
        <h1 className="text-gray-500">{label} {isFieldModified(field) && <span className="text-yellow-600 text-xs">(Modified)</span>}</h1>
        <TextField
          value={caseData?.[field] || ""}
          onChange={handleFieldChange(field)}
          fullWidth
          size="small"
          variant="standard"
          error={!!errorState}
          helperText={errorState}
          inputProps={{ 
            maxLength: 6,
            inputMode: "numeric"
          }}
          InputProps={{ disableUnderline: true }}
          sx={{
            "& .MuiInputBase-input": {
              padding: 0,
              fontSize: "inherit",
              fontFamily: "inherit",
            },
            "& .MuiFormHelperText-root": {
              color: "red",
              marginLeft: 0
            }
          }}
        />
      </div>
    );
  } else if (displayValue) {
    return (
      <div className={`${width} p-2 py-2`}>
        <h1 className="text-gray-500">{label}</h1>
        <h1 className="break-words whitespace-normal" title={displayValue}>{displayValue}</h1>
      </div>
    );
  }
  return null;
}

if (["name", "fatherName", "motherName", "guardianName"].includes(field)) {
  const errorState = {
    name: nameError,
    fatherName: fatherNameError,
    motherName: motherNameError,
    guardianName: guardianNameError
  }[field];

  if (isEditing) {
    return (
      <div className={`${width} p-2 py-2 ${isFieldModified(field) ? 'bg-yellow-50 border-l-4 border-yellow-400' : ''}`}>
        <h1 className="text-gray-500">{label} {isFieldModified(field) && <span className="text-yellow-600 text-xs">(Modified)</span>}</h1>
        <TextField
          value={caseData?.[field] || ""}
          onChange={handleFieldChange(field)}
          fullWidth
          size="small"
          variant="standard"
          error={!!errorState}
          helperText={errorState}
          InputProps={{ disableUnderline: true }}
          sx={{
            "& .MuiInputBase-input": {
              padding: 0,
              fontSize: "inherit",
              fontFamily: "inherit",
            },
            "& .MuiFormHelperText-root": {
              color: "red",
              marginLeft: 0
            }
          }}
        />
      </div>
    );
  } else if (displayValue) {
    return (
      <div className={`${width} p-2 py-2`}>
        <h1 className="text-gray-500">{label}</h1>
        <h1 className="break-words whitespace-normal" title={displayValue}>{displayValue}</h1>
      </div>
    );
  }
  return null;
}

   
    const isDropdown = options !== null;
    if (!shouldShowField(field, displayValue, isDropdown)) return null;
    
    if (isEditing) {
      if (options) {
        const currentValue = getCurrentValue(field);

        return (
          <div className={`${width} p-2 py-2 ${isFieldModified(field) ? 'bg-yellow-50 border-l-4 border-yellow-400' : ''}`}>
            <h1 className="text-gray-500">{label} {isFieldModified(field) && <span className="text-yellow-600 text-xs">(Modified)</span>}</h1>
            <FormControl fullWidth size="small" variant="standard">
              <Select
                value={currentValue}
                onChange={handleSelectFieldChange(field)}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  "& .MuiSelect-select": {
                    padding: 0,
                    fontSize: "inherit",
                    fontFamily: "inherit",
                  },
                  "&:before": {
                    display: "none",
                  },
                  "&:after": {
                    display: "none",
                  },
                }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {options?.map((option) => (
                  <MenuItem
                    key={option.id || option._id}
                    value={option.id || option._id}
                  >
                    {option.name || option.title || option.label || "No name"}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        );
      }

      return (
        <div className={`${width} p-2 py-2 ${isFieldModified(field) ? 'bg-yellow-50 border-l-4 border-yellow-400' : ''}`}>
          <h1 className="break-words whitespace-normal text-gray-500">{label} {isFieldModified(field) && <span className="text-yellow-600 text-xs">(Modified)</span>}</h1>
          <TextField
            className="break-words whitespace-normal"
            value={displayValue || ""}
            onChange={handleFieldChange(field)}
            fullWidth
            size="small"
            variant="standard"
            InputProps={{ disableUnderline: true }}
            sx={{
              "& .MuiInputBase-input": {
                padding: 0,
                fontSize: "inherit",
                fontFamily: "inherit",
              },
            }}
          />
        </div>
      );
    }

    return (
      <div className={`${width} p-2 py-2`}>
        <h1 className="text-gray-500">{label}</h1>
        <h1 className="break-words whitespace-normal" title={displayValue || ""}>{displayValue || ""}</h1>
      </div>
    );
  };

  const getTagsFromIds = (tagIds) => {
    if (!tagIds || !studentTags) return [];
    
    const idArray = Array.isArray(tagIds) ? tagIds : [tagIds];
    
    return idArray
      ?.map(id => studentTags.find(tag => tag.id === id || tag._id === id))
      .filter(tag => tag); 
  };

  const renderStudentTags = () => {
    const tagIds = caseData?.studentTagsId || 
                   (caseData?.studentTagsId ? [caseData.studentTagsId] : []);
    
    const tagObjects = getTagsFromIds(tagIds);
    
    if (isEditing) {
      return (
        <div className={`w-full flex items-center ml-0 mt-2 ${isFieldModified('studentTagsId') ? 'bg-yellow-50 border-l-4 border-yellow-400 pl-2' : ''}`}>
          <TagSharp style={{ marginRight: "8px" }} />
          {isFieldModified('studentTagsId') && <span className="text-yellow-600 text-xs mr-2">(Modified)</span>}
          <FormControl fullWidth size="small" variant="standard">
            <Select
              multiple
              value={selectedStudentTags.length > 0 ? selectedStudentTags : tagIds}
              onChange={handleMultipleTagsChange}
              renderValue={(selected) => (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                  {getTagsFromIds(selected)?.map((tag) => (
                    <Chip 
                      key={tag.id || tag._id} 
                      label={tag.name} 
                      size="small"
                      style={{ height: '20px', fontSize: '0.75rem' }}
                    />
                  ))}
                </div>
              )}
              displayEmpty
              sx={{
                "& .MuiSelect-select": {
                  padding: "2px 0",
                  fontSize: "inherit",
                  fontFamily: "inherit",
                  minHeight: "24px !important",
                },
                "&:before": {
                  display: "none",
                },
                "&:after": {
                  display: "none",
                },
              }}
            >
              <MenuItem value="" disabled>
                <em>Select tags</em>
              </MenuItem>
              {studentTags?.map((tag) => (
                <MenuItem key={tag.id || tag._id} value={tag.id || tag._id}>
                  <Checkbox 
                    checked={(selectedStudentTags.length > 0 ? selectedStudentTags : tagIds).indexOf(tag.id || tag._id) > -1} 
                    size="small"
                  />
                  <ListItemText primary={tag.name || "No name"} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      );
    }

    if (tagObjects.length > 0) {
      return (
        <div className="flex items-center mt-1 flex-wrap gap-1">
          <TagSharp style={{ fontSize: "1rem" }} />
          <div className="flex flex-wrap gap-1">
            {tagObjects?.map(tag => (
              <Chip 
                key={tag.id || tag._id} 
                label={tag.name} 
                size="small"
                style={{ height: '20px', fontSize: '0.75rem' }}
              />
            ))}
          </div>
        </div>
      );
    }

    return null;
  };
  
  useEffect(() => {
    if (isEditing) {
      // Handle both array and single tag cases
      if (caseData?.studentTagsId) {
        setSelectedStudentTags(caseData.studentTagsId);
      } else if (caseData?.studentTagsId) {
        setSelectedStudentTags([caseData.studentTagsId]);
      } else {
        setSelectedStudentTags([]);
      }
      
      if (caseData?.mobile) validateMobileNumber(caseData.mobile, "mobile");
      if (caseData?.fatherMobile) validateMobileNumber(caseData.fatherMobile, "fatherMobile");
      if (caseData?.motherMobile) validateMobileNumber(caseData.motherMobile, "motherMobile");
      if (caseData?.guardianMobile) validateMobileNumber(caseData.guardianMobile, "guardianMobile");
      if (caseData?.email) validateEmail(caseData.email);
      if (caseData?.aadharNo) validateAadharNumber(caseData.aadharNo);
      if (caseData?.prevYearMark) validatePercentage(caseData.prevYearMark);
    }
  }, [isEditing, caseData]);

  return (
    <div className="border-gray-300 border h-fit w-auto mx-5 p-4">
      <div className="flex justify-between items-start">
        <div className="flex">
          <Avatar
            className="cursor-pointer"
            onClick={() => setImageOpen(true)}
            sx={{ width: "80px", height: "80px" }}
            alt={caseData?.firstName}
            src={`${CONSTANTS.baseUrl}/profilePics/user/download/${caseData?.image}`}
          />
          <ImgsViewer
            imgs={[
              {
                src: `${CONSTANTS.baseUrl}/profilePics/user/download/${caseData?.image}`,
              },
            ]}
            isOpen={imageOpen}
            onClose={() => setImageOpen(false)}
          />

          <div className="text-gray-500 ml-4">
            {isEditing ? (
              <>
                <div className={isFieldModified('name') ? 'bg-yellow-50 border-l-4 border-yellow-400 pl-2' : ''}>
                  {isFieldModified('name') && <span className="text-yellow-600 text-xs">(Modified)</span>}
                  <TextField
                    value={caseData?.name || ""}
                    onChange={handleFieldChange("name")}
                    fullWidth
                    size="small"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "1.5rem",
                        lineHeight: "2rem",
                        padding: 0,
                      },
                    }}
                  />
                </div>
                <div className="">{renderStudentTags()}</div>
                <p className={`text-sm mt-2 ${isFieldModified('email') ? 'bg-yellow-50 border-l-4 border-yellow-400 pl-2' : ''}`}>
                  <DraftsIcon fontSize="small" />
                  &nbsp;
                  {isFieldModified('email') && <span className="text-yellow-600 text-xs">(Modified) </span>}
                  <TextField
                    value={caseData?.email || ""}
                    onChange={handleFieldChange("email")}
                    size="small"
                    variant="standard"
                    error={!!emailError}
                    helperText={emailError}
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "0.875rem",
                        padding: 0,
                      },
                      "& .MuiFormHelperText-root": {
                        color: "red",
                        marginLeft: 0
                      }
                    }}
                  />
                </p>
                <p className={`text-sm mt-1 ${isFieldModified('mobile') ? 'bg-yellow-50 border-l-4 border-yellow-400 pl-2' : ''}`}>
                  <LocalPhoneIcon fontSize="small" />
                  &nbsp;
                  {isFieldModified('mobile') && <span className="text-yellow-600 text-xs">(Modified) </span>}
                  <TextField
                    value={caseData?.mobile || ""}
                    onChange={handleFieldChange("mobile")}
                    error={!!mobileError}
                    helperText={mobileError}
                    size="small"
                    variant="standard"
                    inputProps={{ 
                      maxLength: 10,
                      inputMode: "numeric"
                    }}
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "0.875rem",
                        padding: 0,
                      },
                      "& .MuiFormHelperText-root": {
                        color: "red",
                        marginLeft: 0
                      }
                    }}
                  />
                </p>
              </>
            ) : (
              <>
                <h1 className="text-2xl font-medium">
                  {caseData?.name || "N/A"}
                </h1>
                <div className="">{renderStudentTags()}</div>
                {caseData?.email && (
                  <p className="text-sm mt-2">
                    <DraftsIcon fontSize="small" />
                    &nbsp;{caseData?.email}
                  </p>
                )}
                {caseData?.mobile && (
                  <p className="text-sm mt-1">
                    <LocalPhoneIcon fontSize="small" />
                    &nbsp;{caseData?.mobile}
                  </p>
                )}
              </>
            )}
          </div>
        </div>
        
        {caseData.isRegistered && (!isEditing ? (
          <Button
            startIcon={<EditIcon />}
            onClick={onEditClick}
            variant="outlined"
            size="small"
            sx={{
              mt: 1,
              mr: 1,
              textTransform: "none",
              borderRadius: "4px",
            }}
          >
            Edit
          </Button>
        ) : (
          <Stack direction="row" spacing={1} sx={{ mt: 1, mr: 1 }}>
            <Button
              startIcon={<CheckIcon />}
              onClick={() => {
                // Check if there are any validation errors before saving
                if (!mobileError && !fatherMobileError && !motherMobileError && !guardianMobileError && !emailError) {
                  // Make sure we save the selected tags
                  if (selectedStudentTags.length > 0) {
                    onFieldChange("studentTagsId", selectedStudentTags);
                  }
                  onSaveEdit(editedData);
                }
              }}
              variant="contained"
              size="small"
              color="success"
              disabled={!!(mobileError || fatherMobileError || motherMobileError || guardianMobileError || emailError)}
              sx={{
                textTransform: "none",
                borderRadius: "4px",
              }}
            >
              Save
            </Button>
            <Button
              startIcon={<CloseIcon />}
              onClick={onCancelEdit}
              variant="outlined"
              size="small"
              color="error"
              sx={{
                textTransform: "none",
                borderRadius: "4px",
              }}
            >
              Cancel
            </Button>
          </Stack>)
        )}
      </div>

      {caseData && (
        <div className="flex flex-wrap text-sm mt-8">
          {renderField(
            "dob",
            "Date Of Birth",
            null
          )}
          {renderField(
            "bloodGroupId",
            "Blood Group",
            getDisplayNameById(bloodGroups, caseData?.bloodGroupId),
            "w-64",
            bloodGroups
          )}
          {renderField(
            "school",
            "School",
            caseData?.school
          )}
          {renderField(
            "boardId",
            "Board",
            getDisplayNameById(boardData, caseData?.boardId),
            "w-64",
            boardData
          )}
          {renderField(
            "prevYearMark",
            "Previous Year %",
            caseData?.prevYearMark ? `${caseData?.prevYearMark}` : ""
          )}
          {renderField(
            "previousClassId",
            "Previous Class",
            getDisplayNameById(PreviousClass, caseData?.previousClassId),
            "w-64",
            PreviousClass
          )}
          {renderField(
            "countryId",
            "Country",
            caseData?.country,
            "w-64"
          )}
          {renderField(
            "stateId",
            "Permanent state",
            getDisplayNameById(stateData, caseData?.stateId),
            "w-64",
            stateData
          )}
          {renderField(
            "city",
            "Permanent City",
            caseData?.city
          )}
          {renderField(
            "postalCode",
            "Permanent Pincode",
            caseData?.postalCode
          )}
          {renderField( 
            "streetAddress",
            "Permanent Address",
            caseData?.streetAddress,
          )}
          {renderField(
            "currentStateId",
            "Current state",
            getDisplayNameById(stateData, caseData?.currentStateId),
            "w-64",
            stateData
          )}
          {renderField(
            "currentCity",
            "Current City",
            caseData?.currentCity
          )}
          {renderField(
            "currentPostalCode",
            "Current Pincode",
            caseData?.currentPostalCode
          )}
           {renderField( 
            "currentStreetAddress",
            "Current Address",
            caseData?.currentStreetAddress,
          )}
          {renderField("aadharNo", "Aadhar Number", caseData?.aadharNo)}
          {renderField("fatherName", "Father's Name", caseData?.fatherName)}
          {renderField(
            "fatherMobile",
            "Father's Mobile",
            caseData?.fatherMobile
          )}
          {renderField(
            "fatherOccupationId",
            "Father's Occupation",
            getDisplayNameById(occupationData, caseData?.fatherOccupationId),
            "w-64",
            occupationData
          )}
          {renderField("motherName", "Mother's Name", caseData?.motherName)}
          {renderField(
            "motherMobile",
            "Mother's Mobile",
            caseData?.motherMobile
          )}
          {renderField(
            "motherOccupationId",
            "Mother's Occupation",
            getDisplayNameById(occupationData, caseData?.motherOccupationId),
            "w-64",
            occupationData
          )}
          {renderField(
            "guardianName",
            "Guardian's Name",
            caseData?.guardianName
          )}
          {renderField(
            "guardianMobile",
            "Guardian's Mobile",
            caseData?.guardianMobile
          )}
          {renderField(
            "guardianOccupationId",
            "Guardian's Occupation",
            getDisplayNameById(occupationData, caseData?.guardianOccupationId),
            "w-64",
            occupationData
          )}
          {renderField(
            "careerOptionId",
            "Career Option",
            getDisplayNameById(careerOptionData, caseData?.careerOptionId),
            "w-64",
            careerOptionData
          )}
          {renderField(
            "sourceId",
            "Source of info about APT",
            getDisplayNameById(sourceData, caseData?.sourceId),
            "w-64",
            sourceData
          )}
          {renderField(
            "futureCourse",
            "Next Expected Course",
            getDisplayNameById(nextExpectedCourse, caseData.futureCourse),
            "w-64",
            nextExpectedCourse
          )}  

          {!isEditing && caseData?.RegisteredAt && (
            <div className="w-64 p-2 py-2">
              <h1 className="text-gray-500">Registration Date</h1>
              <h1>{moment(caseData?.RegisteredAt).format("MMMM Do YYYY")}</h1>
            </div>
          )}
        </div>
      )}
    </div>
  ); 
}

export default CaseDetailsHeadedCard;